import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as servers from '../../../../services/api/servers';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {urls} from '../../../../services/api/urls';
import {ProjectConstants} from '../../../project-constants';

@Injectable({
  providedIn: 'root'
})
export class ConsuntivoVolumiService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }
  baseUrl: string = servers.apiUrl + urls.consuntivoVolumiController;

  getPage(filters: any, payload?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getComparePage(filters, payload?): Observable<any> {
    const url = this.baseUrl + this.LINKS.COMPARE;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getNameGenerateCsv(offset, payload: any) {
    const url = this.baseUrl + this.LINKS.GENERATE_CSV;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'text', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getNameGenerateXlsx(offset, payload: any, comparing: boolean) {
    let url = this.baseUrl;
    if (comparing) {
      url = url + this.LINKS.GENERATE_COMPARISON_XLSX;
    } else {
      url = url + this.LINKS.GENERATE_XLSX;
    }
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();

    return this.http.post( url, body, {headers: header, responseType: 'blob', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );

  }

  getDownloadCsv(nameCsv: string) {
    const url = this.baseUrl + this.LINKS.DOWNLOAD_CSV + '/' + nameCsv;
    const body = null;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.get(url, {headers: header, responseType: 'text'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  updateWorkflowStatusSingle(offset: Array<any>) {
    const url = this.baseUrl + this.LINKS.UPDATE_WORKFLOW_STAUS_SINGLE;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  updateWorkflowStatusMassive(offset: Array<any>) {
    const url = this.baseUrl + this.LINKS.UPDATE_WORKFLOW_STAUS_MASSIVE;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }


  checkPreliminaryFinal(num_anno_mese:any, providerId:any) {
    const url = this.baseUrl + this.LINKS.CHECK_PRELIMINARY_FINAL;
    const body = null;
    const header = ProjectConstants.returnGeneralHeader();

    const params = {
      numAnnoMese: num_anno_mese,
      providerId: providerId
    };
    return this.http.get(url, {headers: header, responseType: 'text', params: params})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
